<template>
  <div>
    <a-row type="flex" :gutter="[25,25]">
      <a-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16" :xxl="16">
        <tk-flex column>
          <div style="width: 100%; background: white">
            <tk-flex middle>
              <tk-image
                :src="require('../assets/images/home_logo.png')"
                style="height: 142px; width: 189px"
              />
              <tk-flex column style="margin-left: 30px">
                <div style="font-size: 30px; color: #000000">
                  欢迎登录优邻云享管理后台
                </div>
                <div
                  style="font-size: 20px; color: #8a92a1; font-weight: lighter"
                >
                  Welcome to Youlinyunxiang property management background
                </div>
              </tk-flex>
            </tk-flex>
          </div>
          <ak-model-chart
            style="width: 100%; margin-top: 27px"
            title="订单统计"
            :options="chartOptions"
          />
          <a-row style="width: 100%" :gutter="[16, 16]">
            <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="10">
              <div style="margin-top: 27px; background: white">
                <div class="p-l-20 p-t-20 font-16 font-bold">用户余额</div>
                <ak-model-table
                  class="p-20"
                  style="width: 100%"
                  model="userRecharge"
                />
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="14">
              <div style="margin-top: 27px; background: white">
                <div class="p-l-20 p-t-20 font-16 font-bold">今日销量</div>
                <ak-model-table
                  class="p-20"
                  style="width: 100%"
                  model="salesVolume"
                />
              </div>
            </a-col>
          </a-row>
        </tk-flex>
      </a-col>
      <a-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" :xxl="8">
        <tk-flex column style="height: 100%">
          <a-row type="flex" :gutter="[25, 25]">
            <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :xxl="24">
              <my-group-card
                image="all"
                :count="order"
                title="累计收益"
                unit="元"
              />
            </a-col>
            <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" :xxl="12">
              <my-group-card
                image="recharge"
                :count="recharge"
                title="今日用户充值"
                unit="元"
              />
            </a-col>
            <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" :xxl="12">
              <my-group-card
                image="shopping"
                :count="shopping"
                title="今日商品购买"
                unit="元"
              />
            </a-col>
            <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" :xxl="12">
              <my-group-card
                image="water_count"
                :count="water"
                title="今日水费缴纳"
                unit="元"
              />
            </a-col>
            <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" :xxl="12">
              <my-group-card
                image="electric"
                :count="electric"
                title="今日电费缴纳"
                unit="元"
              />
            </a-col>
            <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" :xxl="12">
              <my-group-card
                image="heating"
                :count="heating"
                title="今日取暖费缴纳"
                unit="元"
              />
            </a-col>
            <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" :xxl="12">
              <my-group-card
                image="fee"
                :count="fee"
                title="今日物业费缴纳"
                unit="元"
              />
            </a-col>
          </a-row>

          <a-card
            class="m-t-24"
            style="width: 100%; height: 100%; flex-grow: 1; background: white"
            title="其他信息"
          >
            <tk-flex style="width: 100%; height: 100%" column middle>

              <div class="longCard">
                <tk-flex
                  class="p-x-24 p-y-20"
                  style="width: 100%"
                  middle
                  between
                >
                  <long-card-option
                    image="water_info"
                    title="水费（未处理）"
                    :count="waterObj.paid"
                  />
                  <long-card-option
                    title="水费（已处理）"
                    :count="waterObj.completed"
                  />
                  <a-button
                    style="color: blue; border-color: blue"
                    @click="$router.push({ path: '/model/waterOrder' })"
                  >
                    查看
                  </a-button>
                </tk-flex>
              </div>

              <div class="longCard">
                <tk-flex
                  class="p-x-24 p-y-20"
                  style="width: 100%"
                  middle
                  between
                >
                  <long-card-option
                    image="electricBlue"
                    title="电费（未处理）"
                    :count="electricObj.paid"
                  />
                  <long-card-option
                    title="电费（已处理）"
                    :count="electricObj.completed"
                  />
                  <a-button
                    style="color: blue; border-color: blue"
                    @click="$router.push({ path: '/order/electricityOrder' })"
                  >
                    查看
                  </a-button>
                </tk-flex>
              </div>

              <div class="longCard">
                <tk-flex
                  class="p-x-24 p-y-20"
                  style="width: 100%"
                  middle
                  between
                >
                  <long-card-option
                    image="repair"
                    title="报修（未处理）"
                    :count="unRepairedCount"
                  />
                  <long-card-option
                    title="报修（已处理）"
                    :count="repairedCount"
                  />
                  <a-button
                    style="color: blue; border-color: blue"
                    @click="$router.push({ path: '/model/repair' })"
                  >
                    查看
                  </a-button>
                </tk-flex>
              </div>
              <div class="longCard">
                <tk-flex
                  class="p-x-24 p-y-20"
                  style="width: 100%"
                  middle
                  between
                >
                  <long-card-option
                    image="clean"
                    title="清理（未处理）"
                    :count="unCleanedCount"
                  />
                  <long-card-option
                    title="清理（已处理）"
                    :count="cleanedCount"
                  />
                  <a-button
                    style="color: blue; border-color: blue"
                    @click="$router.push({ path: '/model/cleaning' })"
                  >
                    查看
                  </a-button>
                </tk-flex>
              </div>
              <!-- <div class="longCard">
                <tk-flex
                  class="p-x-24 p-y-20"
                  style="width: 100%"
                  middle
                  between
                >
                  <long-card-option
                    image="news"
                    title="新闻公告"
                    :count="noticeCount"
                  />
                  <a-button
                    style="color: blue; border-color: blue"
                    @click="$router.push({ path: '/model/notice' })"
                  >
                    查看
                  </a-button>
                </tk-flex>
              </div>
              <div class="longCard">
                <tk-flex
                  class="p-x-24 p-y-20"
                  style="width: 100%"
                  middle
                  between
                >
                  <long-card-option
                    image="coupon"
                    title="优惠券"
                    :count="couponCount"
                  />
                  <a-button
                    style="color: blue; border-color: blue"
                    @click="$router.push({ path: '/model/coupon' })"
                  >
                    查看
                  </a-button>
                </tk-flex>
              </div> -->
            </tk-flex>
          </a-card>
        </tk-flex>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import myGroupCard from './components/myGroupCard.vue'
import longCardOption from './components/longCardOption.vue'
export default {
  components: {
    myGroupCard,
    longCardOption
  },
  data () {
    return {
      waterObj: { // 水费订单已处理与未处理
        completed: 0,
        paid: 0
      },
      electricObj: { // 电费订单已处理与未处理
        completed: 0,
        paid: 0
      },
      // goods: 0, // 商品数量
      order: 0, // 总收入
      shopping: 0, // 今日购物金额
      fee: 0, // 今日物业费
      heating: 0, // 今日取暖费
      water: 0, // 今日水费
      electric: 0, // 今日电费
      recharge: 0, // 今日充值
      // userCount: 0, // 用户数量
      // shoppingCount: 0, // 商品订单数量
      // feeCount: 0, // 物业缴费订单数量
      unRepairedCount: 0, // 报修（未处理）数量
      repairedCount: 0, // 报修（已处理）数量
      unCleanedCount: 0, // 清理（未处理）数量
      cleanedCount: 0, // 清理（已处理）数量
      noticeCount: 0, // 新闻公告数量
      couponCount: 0, // 优惠券数量
      options: [
        {
          model: '_User',
          icon: 'user',
          note: '数量用户'
        },
        {
          model: 'goods',
          icon: 'shopping-cart',
          note: '商品数量',
          where: {
            isDelete: {
              $ne: true
            }
          }
        },
        {
          model: 'order',
          icon: 'shopping-cart',
          note: '商品订单',
          where: {
            type: 'shopping',
            isDelete: {
              $ne: true
            }
          }
        },
        {
          model: 'order',
          icon: 'shopping-cart',
          note: '物业缴费订单',
          where: {
            type: 'fee'
          }
        }
      ],
      chartOptions: [
        {
          model: 'order',
          chartType: 'bar', // 图表类型，可选值：line 折线图，bar 柱状图
          name: '商品订单',
          where: {
            type: 'shopping',
            state: {
              $in: ['completed', 'paid']
            }
          },
          color: '#F7C137' // 可选，自定义颜色
        },
        {
          model: 'order',
          chartType: 'bar', // 图表类型，可选值：line 折线图，bar 柱状图
          name: '电费订单',
          where: {
            type: 'electric',
            state: {
              $in: ['completed', 'paid']
            }
          },
          color: '#3742FE' // 可选，自定义颜色
        },
        {
          model: 'order',
          chartType: 'bar', // 图表类型，可选值：line 折线图，bar 柱状图
          name: '水费订单',
          where: {
            type: 'water',
            state: {
              $in: ['completed', 'paid']
            }
          },
          color: '#2FC25B' // 可选，自定义颜色
        }
      ]
    }
  },
  async mounted () {
    let { data: res } = await this.$tkParse.post('/homeGroup')
    console.log('首页数据', res)
    // this.goods = res.goods
    this.order = res.order
    this.shopping = res.shopping
    this.fee = res.fee
    this.heating = res.heating
    this.water = res.water
    this.electric = res.electric
    this.recharge = res.recharge
    this.electricObj = res.electricObj
    this.waterObj = res.waterObj
    // this.userCount = res.userCount
    // this.goodCount = res.goodCount
    // this.shoppingCount = res.shoppingCount
    // this.feeCount = res.feeCount
    this.repairedCount = res.repairedCount
    this.unRepairedCount = res.unRepairedCount
    this.cleanedCount = res.cleanedCount
    this.unCleanedCount = res.unCleanedCount
    // this.noticeCount = res.noticeCount
    // this.couponCount = res.couponCount
  }
  // 一个简单的hasura请求
  // apollo: {
  //   variable: {
  //     query: gql`query MyQuery($sex: String = "") {
  //       _User(where: {sex: {_eq: $sex}}) {
  //         phone
  //         sex
  //         username
  //         objectId
  //       }
  //     }`,
  //     variables () {
  //       return {
  //         sex: 'man'
  //       }
  //     },
  //     async update ({ _User: res }) {
  //       console.log('hasura请求_User数据表返回数据', res)
  //     },
  //     fetchPolicy: 'no-cache' // 解决缓存问题
  //   }
  // }
}
</script>
<style scoped lang="scss">
.longCard {
  border: 1px solid #eeeeee;
  border-radius: 12px;
  width: 100%;
  margin: 12px 0px;
}
</style>
